"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
function ColorSwitchDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/color-switch.html',
        controller: /** @class */ (function (_super) {
            __extends(ColorSwitchController, _super);
            function ColorSwitchController($scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.form.value = book.getIndex(_this.prefix, _this.id);
                _this.setValue(_this.form.value);
                return _this;
            }
            ColorSwitchController.prototype.setValue = function (value) {
                this.form.value = value;
                this.book.update(this.prefix, this.id, value);
            };
            ColorSwitchController.prototype.onClick = function (value) {
                this.setValue(value);
            };
            return ColorSwitchController;
        }(form_1.FormOptionController)),
        controllerAs: 'colorCtrl'
    };
}
exports.ColorSwitchDirective = ColorSwitchDirective;
